// extracted by mini-css-extract-plugin
export var dataCell = "_pr-2";
export var dataRow = "_pr-0";
export var headerRow = "_pr-1";